<script setup>
import {defineProps} from 'vue'
defineProps({
  title: {type:String,value:"Informations sur l'appartement"},
  subTile: {type:String,value:"Toutes les infos sur ce appart"},
})
</script>

<template>
  <!-- PAGE HEADING -->
  <div class="impx-page-heading uk-position-cover room-detail">
    <div class="impx-overlay dark"></div>
    <div class="uk-container">
      <div class="uk-width-1-1">
        <div class="uk-flex uk-flex-left">
          <div class="uk-light uk-position-relative uk-text-left page-title">
            <h1 class="uk-margin-remove">{{title}}</h1><!-- page title -->
            <p class="impx-text-large uk-margin-remove">{{subTile}}</p><!-- page subtitle -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- PAGE HEADING END -->
</template>

<style scoped>

</style>